import './index.scss'
import { Select, SelectItem, SelectItemGroup } from 'carbon-components-react'

Select.Item = SelectItem
Select.ItemGroup = SelectItemGroup

export { Select, SelectItem, SelectItemGroup, Select as default }
